export enum TableauSecurityModel {
  Regional,
  Standard,
  Custom,
}
